export const GRADIENTS: [string, string][] = [
  ['#6366f1', '#8b5cf6'],
  ['#0f9bb0', '#1cc6d4'],
  ['#2e6bff', '#11b3c8'],
  ['#0ea5e9', '#38bdf8'],
  ['#7c3aed', '#a78bfa'],
  ['#059669', '#2dd4bf'],
  ['#3b82f6', '#60a5fa'],
  ['#06b6d4', '#22d3ee'],
  ['#8b5cf6', '#c084fc'],
  ['#0d9488', '#5eead4'],
];

export const DAY_MS = 24 * 60 * 60 * 1000;
